import moment from 'moment-timezone';

export default {
  voucherExpeditionPlace: '',
  voucherType: 'I',
  voucherConsecutive: '',
  voucherCurrency: 'MXN',
  voucherExchangeRate: null,
  voucherSeries: '',
  voucherPaymentType: '01',
  voucherPaymentMethod: 'PUE',
  voucherDate: moment().tz('America/Mexico_City').format(),
  voucherTotal: '',
  voucherSubTotal: '',
  voucherComments: '',
  emitterRegime: '601',
  emitterName: '',
  emitterTradeName: '',
  emitterRfc: '',
  receiverOptionsRfcList: [],
  receiverCfdiUsage: 'G03',
  receiverName: '',
  receiverRfc: '',
  receiverFiscalResidence: '',
  receiverNumRegIdTrib: '',
  receiverZipCode: '',
  receiverTaxRegime: '',
  totalTaxesTransferred: '',
  exportation: '01',
  operation: {
    debt: 0,
    stamped: false,
    owner: 0,
    customer: 0,
    ownerCompany: 0,
    customerCompany: 0,
    status: 0,
    name: '',
    email: '',
    balance: 0,
    expirationDate: new Date(),
    payments: [],
    cfdiStatus: '',
  },
  concepts: [
    {
      identificationNumber: '',
      productServiceKey: '',
      description: '',
      quantity: null,
      unitKey: '',
      amount: null,
      unit: null,
      id: 1,
      subjectToTax: '02',
      taxTransfers: [
        {
          base: null,
          tax: '002',
          factorType: 'Tasa',
          fee: '0.160000',
          amount: null,
          type: 'transfer',
        },
      ],
      retainedTaxes: [],
      localTaxTransfers: [],
      localTaxWithHolds: [],
    },
  ],
  cfdisRelated: [],
  amounts: [],
  complement:
  {
    payments: [
      {
        id: 1,
        wayPay: '01',
        currency: 'MXN',
        amount: '',
        exchangeRate: '1',
        operationNumber: null,
        issuingRfc: null,
        bankName: null,
        issuingAccount: null,
        receiverRfc: null,
        receiverAccount: null,
        paymentDate: moment().unix(),
        documentsRelated: [
          {
            id: 1,
            documentId: '',
            documentSeries: '',
            documentConsecutive: '',
            documentPreviousBalance: '',
            documentCurrency: 'MXN',
            documentExchangeRate: 1,
            documentPartialityNumber: '',
            documentAmountPaid: '',
            documentOutstandingBalance: '',
            documentInvoiceExchangeRate: null,
            documentConversionAmountPaid: '',
            documentTotal: '',
            documentTaxTransfers: [],
            documentTaxWithholdings: [],
            objectImpDr: '',
          },
        ],
        taxes: null,
      },
    ],
  },
};
